export const isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';

/* Storybook and our vitest config replace `process.env.STORYBOOK` at build time. An app that
   defines nothing has no `process` in the browser, so reading it must not throw on import. */
function readIsStorybook() {
    try {
        return process.env.STORYBOOK === 'true';
    } catch {
        return false;
    }
}

export const isStorybook = readIsStorybook();
